'use client';
import { useContext } from 'react';

export function useStrictContext<T>(context: React.Context<T | null>): T {
  const result = useContext(context);
  if (result) {
    return result;
  } else {
    throw new Error('useStrictContext must be used within the corresponding context provider');
  }
}
